export const redirectTo = (url: string) => {
  const globalScope = globalThis as { __AIVIA_REDIRECT_TO__?: (target: string) => void };
  if (globalScope.__AIVIA_REDIRECT_TO__) {
    globalScope.__AIVIA_REDIRECT_TO__(url);
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }
  window.location.assign(url);
};

export const replaceLocation = (url: string) => {
  const globalScope = globalThis as { __AIVIA_REPLACE_LOCATION__?: (target: string) => void };
  if (globalScope.__AIVIA_REPLACE_LOCATION__) {
    globalScope.__AIVIA_REPLACE_LOCATION__(url);
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }
  window.location.replace(url);
};
